<template>
  <Modal v-model="modal" width="650" :closable="false" class="perfect-im" :mask-closable="false" class-name="perfectInfoStyle">
    <template #header>
      <p class="text-align-center mb10">{{ $t('key1001009') }}</p>
      <Alert type="warning" show-icon>{{ textContent }}</Alert>
    </template>
    <Form ref="registerForm" :model="perfectInfoForm" :rules="rules" :label-width="0" @submit.native.prevent>
      <Row style="width: 80%; margin: 0 auto;">
        <template v-if="improveMobileOrCurrency || improveMobile">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem label="" prop="mobile">
              <Input v-model.trim="perfectInfoForm.mobile" clearable :placeholder="$t('key1001001')">
                <Select slot="prepend" v-model="perfectInfoForm.mobileCountryCode" filterable transfer class="reset_select_input">
                  <Option v-for="(item, index) in countrysData" :value="item.twoCode" :key="index">{{ item.areaCodeName }}</Option>
                </Select>
              </Input>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem label="" prop="imageCode">
              <div class="image-code-box">
                <Input v-model.trim="perfectInfoForm.imageCode" clearable :placeholder="$t('key1001002')"/>
                <img :alt="$t('key1001003')" width="110" height="40" style="margin-left: 10px;" :src="captchaImage" @click="getCaptcha"/>
              </div>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem label="" prop="mobileSms">
              <div class="verificationcode_box" :class="languagesVal !== 'zh-CN' ? 'set_verificationcode_box' : ''">
                <Input v-model.trim="perfectInfoForm.mobileSms" clearable :placeholder="$t('key1001004')"></Input>
                <Button size="large" :disabled="talgCode" class="ml10" @click="sendVerificationCode">{{ codeText }}</Button>
              </div>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem label="" prop="password">
              <Input v-model.trim="perfectInfoForm.password" password type="password" :placeholder="$t('key1001005')" autocomplete="new-password"></Input>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem label="" prop="password1">
              <Input v-model.trim="perfectInfoForm.password1" password type="password" :placeholder="$t('key1001006')" autocomplete="new-password"></Input>
            </FormItem>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem label="" prop="email">
              <Input v-model.trim="perfectInfoForm.email" clearable :placeholder="$t('key1001007')"></Input>
            </FormItem>
          </Col>
        </template>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-if="improveMobileOrCurrency || improveCurrency">
          <FormItem prop="distributorCurrency">
            <Select v-model.trim="perfectInfoForm.distributorCurrency" :placeholder="$t('key1001008')" filterable transfer class="reset_select">
              <Option v-for="item in distributorCurrencyList" :label="item.currencyNameCode" :value="item.targetCurrencyCode">{{ item.currencyNameCode }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Checkbox v-model="readFlag" style="margin-bottom:20px;">
            {{ $t('key1000519') }}
            <a class="select_color" @click.stop="gotoTermsOfService">{{ $t('key1000077') }}</a>
            {{ $t('key1000520') }} <a class="select_color" @click.stop="gotoPrivacyPolicy">{{ $t('key1000078') }}</a>
          </Checkbox>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button class="ml20" @click="exitBtn">{{ $t('key1000091') }}</Button>
      <Button v-if="improveMobile || improveMobileOrCurrency" type="primary" @click="registerBtn">{{ $t('key1000111') }}</Button>
      <Button v-if="improveCurrency" type="primary" @click="improveCurrencyBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/index';
import {deleteTicket, errorUrlHandel, getAllCountrysData, getSetLanguages} from "@/utils/common";
import store from '@/store/store';
import {getToken, removeToken} from "@/utils/cookie";
export default {
  name: 'shoppingPerfectInformation',
  data() {
    let v = this;
    return {
      oneItemCol: {
        // 头部筛选区域划分为一等分
        span: 24
      },
      modal: false,
      readFlag: false,
      talgCode: false,
      captchaImage: '',
      codeText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000988'),
      uid: '',
      perfectInfoForm: {
        emailOrMobile: '',
        password: '',
        imageCode: '',
        mobile: '',
        code: '',
        mobileCountryCode: 'CN',
        distributorCurrency: null
      },
      distributorCurrencyList: [],
      rules: {
        mobile: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000147'), trigger: 'blur'}
        ],
        imageCode: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000989'), trigger: 'blur'}
        ],
        mobileSms: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000990'), trigger: 'blur'}
        ],
        password: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000143'), trigger: 'blur'}
        ],
        password1: [
          {validator: v.validatenewPassword(), required: true, trigger: 'blur'}
        ],
        email: [
          {validator: v.validateMailboxFormat(false), required: true, trigger: 'blur'}
        ],
        distributorCurrency: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000991'), trigger: 'change'}
        ],
        timeStop: null,
      },
      countrysData: []
    };
  },
  computed: {
    languagesVal() {
      return getSetLanguages();
    },
    improveMobile() {
      return store.state.improveMobile;
    },
    improveCurrency() {
      return store.state.improveCurrency;
    },
    improveMobileOrCurrency() {
      return store.state.improveMobileOrCurrency;
    },
    textContent() {
      let text = '';
      if (this.improveMobile) {
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000992');
      }
      if (this.improveCurrency) {
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000993');
      }
      if (this.improveMobileOrCurrency) {
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000994');
      }
      return text;
    }
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      await this.systemCurrencyData();
      this.countrysData = await getAllCountrysData('en');
      // 默认为中国手机号 +86
      this.perfectInfoForm.mobileCountryCode = 'CN';
      this.getCaptcha();
      this.modal = true;
    },
    // 发送手机验证码
    sendVerificationCode() {
      let v = this;
      let talg = false;
      if (v.talgCode) return;
      v.$refs.registerForm.validateField("mobile", (error) => {
        if (!error) {
          v.$refs.registerForm.validateField("imageCode", (error) => {
            if (!error) {
              talg = true;
            }
          });
        }
      });
      if (talg) {
        let query = {
          code: v.perfectInfoForm.imageCode, // 图片的验证码
          isValidHasRegistry: 0, // 校验是否已注册 1:要校验
          isvalid: 1, // 1 校验图片验证码  0 不校验
          messageType: v.perfectInfoForm.mobileCountryCode === 'CN' ? 1 : 14, //  类型 1 注册 2 找回密码 3 绑定手机 4找回邮箱 5 登录  14 海外注册
          mobile: v.perfectInfoForm.mobile,
          uid: this.uid,
          mobileCountryCode: v.handleAreaCode(v.perfectInfoForm.mobileCountryCode)
        };
        v.talgCode = true;
        v.axios.post(api.post_ymsUserSetting_sendMobileVerificationCode, query).then(response => {
          if (response.data.code === 0) {
            let time = 60;
            clearInterval(v.timeStop);
            v.timeStop = setInterval(() => {
              time--;
              if (time > 0) {
                v.codeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000995') + time + 'S';
                v.talgCode = true;
              } else {
                time = 60;
                v.codeText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000988');
                clearInterval(v.timeStop); //清除定时器
                v.talgCode = false;
              }
            }, 1000);
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000996'));
          } else {
            v.talgCode = false;
          }
        });
      }
    },
    gotoPrivacyPolicy() {
      window.open(window.location.origin + '/yms-shopping-service/index.html#/privacyPolicy', '_blank');
    },
    gotoTermsOfService() {
      window.open(window.location.origin + '/yms-shopping-service/index.html#/termsOfService', '_blank');
    },
    // 获取图片验证码
    getCaptcha() {
      // 获取当前的时间戳
      this.axios.get(api.get_captcha).then((response) => {
        this.captchaImage = 'data:image/png;base64,' + response.data.datas.base64ImageCode;
        this.uid = response.data.datas.uid;
      });
    },
    // 校验新密码与旧密码
    validatenewPassword() {
      let v = this;
      return function (rule, value, callback) {
        if (!value) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000997')));
        } else if (v.perfectInfoForm.password !== value) {
          return callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000998')));
        } else {
          callback();
        }
      };
    },
    // 立即注册
    registerBtn() {
      let v = this;
      v.$refs['registerForm'].validate((valid) => {
        if (valid) {
          if (v.readFlag) {
            // delete v.registerForm.password1;
            let query = {
              mobile: v.perfectInfoForm.mobile,
              imageCode: v.perfectInfoForm.imageCode,
              mobileSms: v.perfectInfoForm.mobileSms,
              password: v.perfectInfoForm.password,
              email: v.perfectInfoForm.email,
              distributorCurrency: v.perfectInfoForm.distributorCurrency,
              uid: v.uid,
              mobileCountryCode: v.handleAreaCode(v.perfectInfoForm.mobileCountryCode),
              messageType: v.perfectInfoForm.mobileCountryCode === 'CN' ? 1 : 14 // 1- 国内注册 或者 14- 境外注册
            };
            v.axios.put(api.put_ymsDistributorMerchant_updateMerchant, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000999'));
                v.modal = false;
                setTimeout(() => {
                  window.location.reload();
                }, 500);
              }
            });
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001000'));
            return false;
          }
        }
      });
    },
    // 完善币种信息
    improveCurrencyBtn() {
      let v = this;
      v.$refs['registerForm'].validate((valid) => {
        if (valid) {
          if (v.readFlag) {
            let url = api.post_ymsDistributorMerchant_saveCurrency + `?currency=${v.perfectInfoForm.distributorCurrency}`;
            v.axios.post(url, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000999'));
                v.modal = false;
                setTimeout(() => {
                  window.location.reload();
                }, 500);
              }
            });
          } else {
            v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001000'));
            return false;
          }
        }
      });
    },
    // 退出按钮
    exitBtn() {
      this.axios.get(api.get_logout + getToken()).then(response => {
        if (response.data.code === 0) {
          removeToken().then(() => {
            let url = deleteTicket(window.location.href);
            url = errorUrlHandel(url);
            window.location.href = response.data.others.logOutUrl + encodeURIComponent(url);
          });
        }
      });
    },
    // 获取分销商币种
    async systemCurrencyData() {
      let response = await this.axios.get(api.get_ymsCurrencyConfig_query + `?merchantType=3`);
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        this.distributorCurrencyList = data.map((item) => {
          item.currencyNameCode = item.currencyName + ' ' + item.targetCurrencyCode;
          return item;
        });
      }
    },
    // 校验邮箱格式 (默认校验邮箱必填，required 为false时，不校验邮箱必填) 可共用
    validateMailboxFormat(required = true) {
      let v = this;
      let isMailbox = v.$regular.isMailbox;
      return function (rule, value, callback) {
        if (required) {
          if (value === "") {
            callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000145')));
          } else if (!isMailbox.test(value)) {
            callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000146')));
          }
        } else {
          if (value && !isMailbox.test(value)) {
            callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000146')));
          }
        }
        callback();
      };
    },
  }
};
</script>

<style>
.perfect-im .ivu-modal-header {
  border-bottom: 0;
  padding: 16px 14px 0 14px;
}
</style>

<style lang="less" scoped>

/deep/ .perfectInfoStyle {
  .image-code-box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      cursor: pointer;
    }
  }

  .send-code {
    position: absolute;
    top: 0;
    right: 8px;
    line-height: 34px;
    color: #FD5425;
    cursor: pointer
  }

  .perfect-im-modal-header {
    border-bottom: 0;
  }

  .text-align-center {
    text-align: center;
  }

  .ivu-form-item {
    input {
      height: 40px;
      line-height: 40px;
    }
  }

  .ivu-form-item .reset_select {
    .ivu-select-selection {
      height: 40px;
    }
  }

  .verificationcode_box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    input {
      width: 374px;
    }

    .ivu-btn-default {
      width: 135px !important;
    }

    img {
      cursor: pointer;
    }
  }

  .set_verificationcode_box {
    input {
      width: 356px !important;
    }

    .ivu-btn-default {
      width: 165px !important;
    }
  }

  .reset_select_input {
    width: 120px;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;

    .ivu-select-selection {
      height: 40px;
    }
  }

  .ivu-input-group-prepend {
    background-color: transparent;
  }
}
</style>
